import { get } from './fetch'

export const getRates = () => {
  return get(`finance/currency-rates`, false)
}
